import * as React from 'react'
import { Tooltip } from '@material-ui/core'

interface IProps {
	color?: string
	size?: string
	title?: string
}

const CircleIcon = ({ color = '#323232', size = '14px', title }: IProps) => {
	const circleStyle = {
		backgroundColor: color,
		borderRadius: '50%',
		height: size,
		width: size,
	}

	const Icon = <div style={circleStyle} />

	return <>{!!title ? <Tooltip title={title}>{Icon}</Tooltip> : Icon}</>
}

export default React.memo(CircleIcon)



// WEBPACK FOOTER //
// ./src/component/shared/custom-icons/CircleIcon.tsx